import { type ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { BlackDiamondWPContactSyncSettings } from './BlackDiamondWPContactSyncSettings'

export const BlackDiamondWPSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <BlackDiamondWPContactSyncSettings /> }]
}
